<template>
  <div
    data-slot="input-group"
    role="group"
    :class="
      cn(
        'tw:group/input-group tw:border-input tw:dark:bg-input/30 tw:relative tw:flex tw:w-full tw:items-center tw:rounded-md tw:border tw:shadow-xs tw:transition-[color,box-shadow] tw:outline-none',
        'tw:h-10 tw:min-w-0 tw:has-[>textarea]:h-auto',
        'tw:h-[calc(2.8rem+2px)]',

        // Variants based on alignment.
        'tw:has-[>[data-align=inline-start]]:[&>input]:pl-2',
        'tw:has-[>[data-align=inline-end]]:[&>input]:pr-2',
        'tw:has-[>[data-align=block-start]]:h-auto tw:has-[>[data-align=block-start]]:flex-col tw:has-[>[data-align=block-start]]:[&>input]:pb-3',
        'tw:has-[>[data-align=block-end]]:h-auto tw:has-[>[data-align=block-end]]:flex-col tw:has-[>[data-align=block-end]]:[&>input]:pt-3',

        // Focus state.
        'tw:has-[[data-slot=input-group-control]:focus-visible]:ring-ring tw:has-[[data-slot=input-group-control]:focus-visible]:ring-2 tw:has-[[data-slot=input-group-control]:focus-visible]:ring-offset-2 tw:has-[[data-slot=input-group-control]:focus-visible]:ring-offset-background',
        'tw:has-[[data-slot=input-group-control]:focus-visible]:border-ring tw:has-[[data-slot=input-group-control]:focus-visible]:ring-ring/50 tw:has-[[data-slot=input-group-control]:focus-visible]:ring-[3px] tw:has-[[data-slot=input-group-control]:focus-visible]:ring-offset-0',

        props.class,
      )
    "
  >
    <slot />
  </div>
</template>

<script setup>
import { cn } from '@/shadcn/lib/utils'

const props = defineProps({
  class: { type: null, required: false },
})
</script>
